import React from "react";

import { useWindowNativeEventListener } from "./use-window-native-event-listener";

export interface UseElementPositionProps {
	initialValue?: {
		x: number;
		y: number;
	};
}

export const useElementPosition = (props: UseElementPositionProps) => {
	const { initialValue } = props;
	const mouseDownPositionRef = React.useRef<{ x: number; y: number } | null>(null);
	const [position, setPosition] = React.useState<{ x: number; y: number }>(
		() => initialValue ?? { x: 0, y: 0 },
	);

	useWindowNativeEventListener(window, "mousemove", (event) => {
		if (mouseDownPositionRef.current) {
			const deltaX = event.clientX - mouseDownPositionRef.current.x;
			const deltaY = event.clientY - mouseDownPositionRef.current.y;
			mouseDownPositionRef.current = { x: event.clientX, y: event.clientY };
			setPosition({ x: position.x + deltaX, y: position.y + deltaY });
		}
	});
	useWindowNativeEventListener(window, "mouseup", () => {
		mouseDownPositionRef.current = null;
	});
	useWindowNativeEventListener(window, "contextmenu", (event) => {
		mouseDownPositionRef.current = null;
	});

	const onMouseDownElement = (event: React.MouseEvent<HTMLElement>) => {
		mouseDownPositionRef.current = { x: event.clientX, y: event.clientY };
	};

	const resetInitialPosition = () => {
		setPosition(initialValue ?? { x: 0, y: 0 });
	};

	return { position, setPosition, onMouseDownElement, resetInitialPosition };
};
